import React from 'react'
// import Dcp from './pages/Dcpimport/Dcp'
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Dcp from './Pages/DcpImport/Dcp'
import { Box, CircularProgress, createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import router from './Routes/Routes';
import { RouterProvider } from 'react-router-dom';


const theme = createTheme({
  typography: {
       fontFamily: "'Poppins', 'Poppins Regular', 'Poppins Medium', sans-serif",
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            height: "33px",
            borderRadius: 0,
            boxSizing: "border-box",
            fontSize: 12,
          },
          "& .MuiInputBase-input": {
            fontSize: 12,
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          "& .MuiAutocomplete-option": {
            fontSize: 12,
            paddingTop: "4px",
            paddingBottom: "4px",
          },
        },
      },
    },
 
    
  },
  // components: {
  //   MuiTableCell: {
  //     styleOverrides: {
  //       root: {
  //         fontFamily: '"Poppins", sans-serif',
  //       },
  //     },
  //   },
  //   MuiTypography: {
  //     styleOverrides: {
  //       root: {
  //         fontFamily: '"Poppins", sans-serif',
  //       },
  //     },
  //   },
  //   MuiButton: {
  //     styleOverrides: {
  //       root: {
  //         fontFamily: '"Poppins", sans-serif',
  //       },
  //     },
  //   },
  // },
});


const FullScreenLoader = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
      }}
    >
      <CircularProgress size={70} thickness={4} color="primary" />
    </Box>
  );
};


const App = () => {
  return (

    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
    </ThemeProvider>
  )
}

export default App





// import React from 'react'
// import Table1 from './Pages/DcpImport/Table1'

// export const App = () => {
//   return (
//      <Table1/>
//   )
// }

// export default App